<template>
  <ul class="type-filters">
    <ToggleFacet v-for="facet in facets" :key="facet.id" :facet="facet"/>
  </ul>
</template>

<script>
import ToggleFacet from "./ToggleFacet";
import {mapGetters} from "vuex";

export default {
  name: "TypeFacets",
  components: {ToggleFacet},
  props: [],
  computed: {
    ...mapGetters({
      facets: 'search/typeFacets',
    })
  }
}
</script>

<style lang="scss" scoped>

.type-filters {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0;
  list-style: none;

}

@media all and (min-width: 768px) {
  .type-filters {
    justify-content: flex-end;
  }
}

</style>